<template>
  <el-form
    ref="loginForm"
    :model="loginForm"
    :rules="fieldRules"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
  >
    <span class="tool-bar">
      <!-- 主题切换 -->
      <theme-picker
        style="float:right;"
        class="theme-picker"
        :default="themeColor"
        @onThemeChange="onThemeChange"
      />
      <!-- 语言切换 -->
      <!-- <lang-selector class="lang-selector"></lang-selector>    -->
    </span>
    <h2 class="title" style="padding-left:22px;">
      {{ appName }}
    </h2>
    <div style="display:flex;justify-content: flex-end">
      <el-button type="text" @click="openFace">
        人脸登录
      </el-button>
    </div>
    <el-form-item prop="account">
      <el-input
        ref="account"
        v-model="loginForm.account"
        type="text"
        auto-complete="off"
        placeholder="账号"
        @keyup.native="accountEnter($event)"
        @blur.prevent="getCaptcha"
      />
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        ref="password"
        v-model="loginForm.password"
        type="password"
        auto-complete="off"
        placeholder="密码"
        @keyup.enter.native="login"
      />
    </el-form-item>
    <el-form-item v-if="loginForm.src">
      <el-col :span="12">
        <el-form-item prop="captcha">
          <el-input
            v-model="loginForm.captcha"
            type="test"
            auto-complete="off"
            placeholder="验证码, 单击图片刷新"
            style="width: 100%;"
            @keyup.enter.native="login"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col class="line" :span="1">
        &nbsp;
      </el-col>
      <el-col :span="11">
        <el-form-item>
          <img
            style="width: 100%;"
            class="pointer"
            :src="loginForm.src"
            @click="getCaptcha"
          />
        </el-form-item>
      </el-col>
    </el-form-item>
    <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
    <el-form-item style="width:100%;">
      <el-button
        type="primary"
        style="width:48%;"
        @click.native.prevent="reset"
      >
        重 置
      </el-button>
      <el-button
        type="primary"
        style="width:48%;"
        :loading="loading"
        @click.native.prevent="login"
      >
        登 录
      </el-button>
    </el-form-item>
    <el-dialog
      v-dialogDrag
      width="500px"
      :visible.sync="dialogVisibleface"
      :before-close="close"
      :show-close="false"
      @open="facekey = true"
    >
      <WebRTCFaceRecognition
        v-if="facekey"
        ref="WebRTCFaceRecognition"
        @update="submit"
      ></WebRTCFaceRecognition>
    </el-dialog>
    <el-dialog v-dialog-drag width="60%" :visible.sync="dialogVisibleHelp">
      <img
        v-if="jtimg"
        style="width:914px;margin-top:50px"
        src="../../static/img/help.png"
        alt=""
      />
      <img
        v-else
        style="width:914px;margin-top:50px"
        src="../../static/img/help.gif"
        alt=""
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="jtimg = true">取消动画</el-button>
        <el-button type="primary" @click="jtimg = false">查看动画</el-button>
      </span>
    </el-dialog>
  </el-form>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import ThemePicker from "@/components/ThemePicker";
import WebRTCFaceRecognition from "@/components/faceapi/WebRTCFaceRecognition";
import versionUpdate from "@/utils/versionUpdate";
export default {
  name: "Login",
  components: {
    ThemePicker,
    WebRTCFaceRecognition
  },
  data() {
    return {
      jtimg: true,
      dialogVisibleHelp: false,
      facekey: false,
      dialogVisibleface: false,
      lastTimeStamp: 0, // 标记当前事件函数的时间戳
      loading: false,
      loginForm: {
        account: "",
        password: "",
        captcha: "",
        src: ""
      },
      fieldRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      checked: true
    };
  },
  computed: {
    ...mapState({
      appName: state => state.app.appName,
      themeColor: state => state.app.themeColor
    })
  },
  provide() {
    return {
      close: this.close
    };
  },
  mounted() {
    // this.refreshCaptcha()
    this.$refs.account.focus();
  },
  methods: {
    openFace() {
      this.dialogVisibleface = true;
      if (!navigator.mediaDevices) {
        this.dialogVisibleHelp = true;
      }
    },
    // 人脸采集
    submit(src) {
      sessionStorage.setItem(
        "tkn",
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ"
      );
      // Cookies.set("token", 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ');
      this.axios({
        url: this.zuul + "/xyj-aiauto/w/sysUserFace/compareFaceBASE64/0",
        method: "post",
        params: {
          fileBase64: src
        }
      })
        .then(res => {
          this.facelogin(res.data.faceurl, res.data.regId, res.data.regtype);
        })
        .catch(err => {
          this.facekey = false;
          this.$message.error(err.message);
          setTimeout(() => {
            this.facekey = true;
          }, 200);
        });
    },
    // 业务库登录
    facelogin(url, id, memo) {
      this.axios({
        url: this.zuul + "/xyj-admin/r/facelogin",
        method: "post",
        params: {
          faceurl: url,
          id: id,
          type: memo
        }
      })
        .then(res => {
          // Cookies.remove('token');
          sessionStorage.removeItem("tkn");
          if (res.data.token.token) {
            // 放置token到Cookie
            // Cookies.set("token", res.data.token.token);
            sessionStorage.setItem("tkn", res.data.token.token);
          } else {
            // Cookies.set("token", res.data.token); // 放置token到Cookie
            sessionStorage.setItem("tkn", res.data.token);
          }
          sessionStorage.setItem("userid", res.data.loginInfo.userid);
          sessionStorage.setItem("user", res.data.loginInfo.username); // 保存用户到本地会话
          sessionStorage.setItem(
            "createTime",
            res.data.loginInfo.user.createTime
          ); // 保存用户注册时间到本地会话
          sessionStorage.setItem("chatid", res.data.chatid); // 保存聊天ID到本地会话
          sessionStorage.setItem("branchCode", res.data.branchCode); // 保存branchCode到本地会话
          sessionStorage.setItem("branchId", res.data.branchId); // 保存branchCode到本地会话
          setTimeout(() => {
            // 用于订阅mqtt消息判断
            this.$addStorageEvent(2, "userid", res.data.loginInfo.userid);
          }, 800);
          // sessionStorage.removeItem('branchCode')
          this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
          this.getControl();
          this.$router.push("/"); // 登录成功，跳转到主页
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    close() {
      // 关闭摄像头
      if (navigator.mediaDevices) {
        this.$refs.WebRTCFaceRecognition.fnClose();
      }
      this.facekey = false;
      this.dialogVisibleface = false;
    },
    /**
     *宋建国：2019/7/30 9:25
     *描述：当输入账号回车时光标移动到密码位置
     */
    accountEnter(event) {
      /* if(event.keyCode != 13){//除回车键外
          //标记当前事件函数的时间戳
          this.lastTimeStamp = event.timeStamp;
          setTimeout(() => {
              //1s后比较二者是否还相同（因为只要还有事件触发，lastTimeStamp就会被改写，不再是当前事件函数的时间戳）
              if(this.lastTimeStamp == event.timeStamp){
                if(this.loginForm.account){
                  this.getCaptcha()
                }
              }
          }, 1000);
      }*/
      if (event.keyCode == 13 && this.loginForm.account.length > 0) {
        this.$refs.password.focus();
      }
    },
    // 获取验证码
    getCaptcha() {
      this.axios({
        url: this.zuul + "/xyj-admin/w/getPcCaptcha",
        method: "get",
        params: {
          userName: this.loginForm.account
        }
      })
        .then(res => {
          if (res) {
            this.loginForm.src = res.msg;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 聊天是否展示请求判断
    getControl() {
      this.jquery.ajax({
        headers: {
          token: sessionStorage.getItem("tkn"),
          "Content-Type": "application/json;charset=UTF-8"
        },
        url: this.zuul + "/xyj-admin/r/sysProject/chatStat",
        type: "get",
        async: false,
        processData: false,
        success: function(data) {
          sessionStorage.setItem("chat_funciton", data.msg);
        }
      });
    },
    async login() {
      sessionStorage.removeItem("tkn");
      const _this = this;
      this.loading = true;
      const userInfo = {
        account: this.loginForm.account,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha,
        usertype: 0
      };
      this.axios({
        url: this.zuul + "/xyj-admin/r/login",
        method: "post",
        data: userInfo
      })
        .then(res => {
          if (res.data.token.token) {
            // 放置token到Cookie
            // Cookies.set("token", res.data.token.token);
            sessionStorage.setItem("tkn", res.data.token.token);
          } else {
            // Cookies.set("token", res.data.token); // 放置token到Cookie
            sessionStorage.setItem("tkn", res.data.token);
          }
          // 判断上次账号与本次账号是否同一人，如果不相同清除上次历史记录
          let ovlUserInfo = JSON.parse(
            sessionStorage.getItem("userInfo") || "{}"
          );
          sessionStorage.setItem("userid", res.data.loginInfo.userid);
          sessionStorage.setItem("user", userInfo.account); // 保存用户到本地会话
          sessionStorage.setItem(
            "createTime",
            res.data.loginInfo.user.createTime
          ); // 保存用户注册时间到本地会话
          sessionStorage.setItem("chatid", res.data.chatid); // 保存聊天ID到本地会话
          sessionStorage.setItem("branchCode", res.data.branchCode); // 保存branchCode到本地会话
          sessionStorage.setItem("branchId", res.data.branchId); // 保存branchCode到本地会话
          sessionStorage.setItem(
            "userInfo",
            JSON.stringify({
              userId: res.data.loginInfo.userid,
              chatid: res.data.chatid,
              userName: res.data.loginInfo.username,
              empname: res.data.loginInfo.empname,
              token: res.data.token.token,
              branchId: res.data.branchId,
              branchCode: res.data.branchCode,
              empLogo: res.data.headlogo
            })
          );

          setTimeout(() => {
            this.$addStorageEvent(2, "userid", res.data.loginInfo.userid);
          }, 800);
          // sessionStorage.removeItem('branchCode')
          this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
          this.getControl();
          // 版本判断是否更新缓存
          versionUpdate.isNewVersion(false);


          // 查看是否有历史记录
          let redirectToPageData = JSON.parse(
            localStorage.getItem("redirectToPageData") || "{}"
          );
          // 判断与上次浏览是否同一人
          if (ovlUserInfo.userId != res.data.loginInfo.userid) {
            this.$store.commit("updateMainTabs", []);
            localStorage.removeItem("redirectToPageData");
          }

          this.$router.push('/')
          this.loading = false;

        })
        .catch(err => {
          this.getCaptcha();
          this.$message.error(err.message);
          this.loading = false;
        });
    },
    refreshCaptcha() {
      this.loginForm.src =
        this.zuul + "/xyj-admin/r/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields();
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit("setThemeColor", themeColor);
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 100px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    // margin: 0px auto 30px auto;
    margin: 0px auto 15px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}
.login-container /deep/ .el-dialog__header,
.login-container /deep/ .el-dialog__body {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue